import { useContext } from "react";
import { ThemeContext } from "@/providers/ThemeProvider";
import type { ThemeContextProps } from "@/types/providers/theme";

export function useTheme() {
  const { theme, toggleTheme } = useContext(ThemeContext) as ThemeContextProps;
  const colors = theme;
  return { theme, toggleTheme, colors };
}
